/* istanbul ignore file */
import {
    AnyAction,
    createSlice,
    PayloadAction,
    Reducer,
} from '@reduxjs/toolkit';

import { initialStateYourFinance as initialState } from './yourFinanceStates';
import { YourFinanceDetail, YourFinanceState, YourFinanceSubmit } from './yourFinanceTypes';
import { LOAN_PURPOSE_ID } from '../../types';

const yourFinanceSlice = createSlice({
    name: 'yourFinance',
    initialState,
    reducers: {

        getYourFinanceFulfilled(state, action: PayloadAction<YourFinanceState>) {
            state.data = action.payload.data;
        },

        prepareSubmitYourFinance(state, action: PayloadAction<YourFinanceDetail>) {
            const yourFinanceDetail = action.payload;

            const {
                bladeName, loanPurposeId, subLoanPurposeId, amountData, dependants,
            } = yourFinanceDetail;
            const {
                netIncome, rent, repayment, creditLimit,
            } = amountData;

            const isGreen = !!(loanPurposeId === LOAN_PURPOSE_ID.GREEN_PURCHASES
            || subLoanPurposeId === LOAN_PURPOSE_ID.NEW_ELECTRIC_HYBRID
            || subLoanPurposeId === LOAN_PURPOSE_ID.USED_ELECTRIC_HYBRID_LESS_THAN_7_YEARS
            || subLoanPurposeId === LOAN_PURPOSE_ID.USED_ELECTRIC_HYBRID_MORE_THAN_7_YEARS);

            state.submitData = {
                bladeName,
                incomeDetails: {
                    taxType: netIncome?.beforeTax ? 'BeforeTax' : 'AfterTax',
                    totalIncome: netIncome?.amount ?? 0,
                    frequency: netIncome?.frequency ?? 'Yearly',
                },
                productType: isGreen ? 'Green' : 'Standard',
                loanPurposeId: subLoanPurposeId === LOAN_PURPOSE_ID.INVALID ? loanPurposeId : subLoanPurposeId,
                expensesDetails: {
                    rent: rent?.amount ?? 0,
                    rentFrequency: rent?.frequency ?? 'Monthly',
                    existingDebt: repayment?.amount ?? 0,
                    existingDebtFrequency: repayment?.frequency ?? 'Yearly',
                    creditCardLimits: creditLimit?.amount ?? 0,
                },
                totalDependents: Number(dependants) ?? 0,
            };

            state.isSubmitDataReady = true;
        },

        setSubmitDataReadyState(state, action: PayloadAction<boolean>) {
            state.isSubmitDataReady = action.payload;
        },

        submitYourFinance(state, action: PayloadAction<YourFinanceSubmit>) {
            // state.data = action.payload.data;
        },
    },
});

export const {
    getYourFinanceFulfilled,
    prepareSubmitYourFinance,
    setSubmitDataReadyState,
    submitYourFinance,
} = yourFinanceSlice.actions;

export const yourFinanceReducer: Reducer<YourFinanceState, AnyAction> = yourFinanceSlice.reducer;
